<div class="flex w-96 flex-col rounded-lg border" *transloco="let t">
  <div class="grow px-5 py-4">
    <p class="line-clamp-1 break-words text-lg font-bold text-primary">
      {{
        'portal.trainings.trainingNameKeys.' + learningPlanInstanceDetails?.name
          | translocoWithFallback: undefined : learningPlanInstanceDetails?.name
      }}
    </p>
  </div>
  @if (loading) {
    <div class="flex h-28 items-center justify-center px-5 pb-4">
      <app-loading class="size-12"></app-loading>
    </div>
  } @else {
    <div class="flex h-28 items-center">
      @if (learningPlanInstanceDetails) {
        <div class="flex items-center px-5 pb-4">
          <div class="size-24">
            <app-doughnut-chart
              [percentage]="completionPercentage"
            ></app-doughnut-chart>
          </div>

          <div class="p-4">
            <p class="text-4xl font-semibold text-primary">
              {{ completionPercentage + '%' }}
            </p>
          </div>
          <div class="flex flex-col">
            <app-badge
              class="mb-1"
              [text]="enrolledStudentsDisplay"
              [type]="enrollmentBadgeType"
              [icon]="'person'"
            >
            </app-badge>

            @if (learningPlanInstanceDetailsStatus && !isDeadlinePassed) {
              <app-learning-plan-status
                [status]="learningPlanInstanceDetailsStatus"
              >
              </app-learning-plan-status>
            }
          </div>
        </div>
      }
    </div>
  }

  <div class="flex items-center justify-center gap-2 rounded-b-lg px-5 pb-4">
    @if (courseInstance.phase) {
      <app-primary-button
        class="w-full"
        [type]="buttonType.TRAILING_OPEN_ICON"
        [attr.id]="isFirstCard ? 'ProductFruitsCardButton' : null"
        [text]="t('portal.courses.dashboard.openLearningPlan')"
        (buttonClicked)="
          goToLearningPlanDetails(courseInstance.phase.learningPlanInstanceId)
        "
      />
    } @else {
      <app-primary-button
        [text]="t('portal.courses.dashboard.setupCourseButton')"
        (buttonClicked)="goToCourseDetails(courseInstance.id)"
      />
    }
  </div>
</div>
